export default {
  methods: {
    /**
     * Add search cache into store
     */
    addCache(data, fullPath) {
      this.$store.commit('search/addCache', {
        data,
        path: fullPath,
      })
    },

    /**
     * Get search cache from store
     */
    getSearchCache() {
      return this.hasCache() ? this.$store.getters['search/getCache'](this.$route.fullPath).data : null
    },

    hasCache() {
      return this.$store.getters['search/hasCache'](this.$route.fullPath)
    },
  },
}
